import { render, staticRenderFns } from "./PlanMargins.vue?vue&type=template&id=823e7688&scoped=true"
import script from "./PlanMargins.vue?vue&type=script&lang=js"
export * from "./PlanMargins.vue?vue&type=script&lang=js"
import style0 from "./PlanMargins.vue?vue&type=style&index=0&id=823e7688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823e7688",
  null
  
)

export default component.exports